import(/* webpackMode: "eager" */ "/vercel/path0/casey-scholar-app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogPageView"] */ "/vercel/path0/casey-scholar-app/components/posthog-pageview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/casey-scholar-app/components/posthog-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/casey-scholar-app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
